import { getStore } from '~/mobx/AppStore';
import getSelectedElectionAttribute from './getSelectedElectionAttribute';
import getSelectedElectionUpdateAttributes from './getSelectedElectionUpdateAttributes';
import { ELECTION_FIELD_CONFIG } from '~/consts/generalSettings';

const setElectionData = async () => {
    const { generalSettingsStore } = getStore();

    const { preSelectElectionId, latestElectionId, selectedElectionData } = generalSettingsStore;
    const { attributes = [] } = selectedElectionData;
    const electionDescription = getSelectedElectionAttribute(attributes, ELECTION_FIELD_CONFIG.electionSLagDescription);
    const electionHowToVote = await getSelectedElectionAttribute(
        attributes,
        ELECTION_FIELD_CONFIG.electionHowToVoteDescription
    );

    generalSettingsStore.setSlagDescription(electionDescription?.value || '');
    generalSettingsStore.setSlagHowToVote(electionHowToVote?.value || '');

    const attributesToUpdate = await getSelectedElectionUpdateAttributes(attributes);
    generalSettingsStore.setCompanyElectionData(attributesToUpdate);

    if (preSelectElectionId !== latestElectionId) {
        generalSettingsStore.setIsSettingsDisabled(true);
    } else {
        generalSettingsStore.setIsSettingsDisabled(false);
    }
};

export default setElectionData;
